export enum GhostState {
  IDLE = "IDLE",
  ROAMING = "ROAMING",
  DETECTING_LURE = "DETECTING_LURE",
  INVESTIGATING = "INVESTIGATING",
  IGNORING_LURE = "IGNORING_LURE",
  INTERACTING = "INTERACTING",
  MIRROR_PICKUP = "MIRROR_PICKUP",
  MIRROR_THROWING = "MIRROR_THROWING",
  AGGRESSIVE = "AGGRESSIVE",
  ALERTED = "ALERTED",
  ESCAPING = "ESCAPING",
  HIDING = "HIDING",
  FEAR_HIDING = "FEAR_HIDING",
  VULNERABLE = "VULNERABLE",
  CAPTURE_READY = "CAPTURE_READY",
  CAPTURING = "CAPTURING",
  RECOVERING = "RECOVERING",
  CAPTURED = "CAPTURED",
}

const TRANSITIONS: Readonly<Record<GhostState, readonly GhostState[]>> = {
  [GhostState.IDLE]: [GhostState.ROAMING, GhostState.DETECTING_LURE, GhostState.ALERTED, GhostState.CAPTURE_READY],
  [GhostState.ROAMING]: [GhostState.IDLE, GhostState.DETECTING_LURE, GhostState.ALERTED, GhostState.ESCAPING, GhostState.HIDING, GhostState.CAPTURE_READY],
  [GhostState.DETECTING_LURE]: [GhostState.INVESTIGATING, GhostState.ROAMING, GhostState.ALERTED, GhostState.CAPTURE_READY],
  [GhostState.INVESTIGATING]: [GhostState.IGNORING_LURE, GhostState.INTERACTING, GhostState.ALERTED, GhostState.CAPTURE_READY],
  [GhostState.IGNORING_LURE]: [GhostState.ROAMING, GhostState.ALERTED, GhostState.CAPTURE_READY],
  [GhostState.INTERACTING]: [GhostState.ALERTED, GhostState.ROAMING, GhostState.CAPTURE_READY],
  [GhostState.MIRROR_PICKUP]: [GhostState.INTERACTING, GhostState.MIRROR_THROWING, GhostState.CAPTURE_READY, GhostState.ROAMING],
  [GhostState.MIRROR_THROWING]: [GhostState.AGGRESSIVE, GhostState.CAPTURE_READY, GhostState.ROAMING],
  [GhostState.AGGRESSIVE]: [GhostState.AGGRESSIVE, GhostState.ALERTED, GhostState.ROAMING, GhostState.CAPTURE_READY],
  [GhostState.ALERTED]: [GhostState.ESCAPING, GhostState.ROAMING, GhostState.CAPTURE_READY],
  [GhostState.ESCAPING]: [GhostState.HIDING, GhostState.FEAR_HIDING, GhostState.ROAMING, GhostState.CAPTURE_READY],
  [GhostState.HIDING]: [GhostState.ROAMING, GhostState.DETECTING_LURE, GhostState.CAPTURE_READY],
  [GhostState.FEAR_HIDING]: [GhostState.ROAMING, GhostState.INVESTIGATING, GhostState.DETECTING_LURE, GhostState.CAPTURE_READY],
  [GhostState.VULNERABLE]: [GhostState.CAPTURE_READY, GhostState.ALERTED, GhostState.ROAMING],
  [GhostState.CAPTURE_READY]: [GhostState.CAPTURING, GhostState.RECOVERING],
  [GhostState.CAPTURING]: [GhostState.CAPTURED],
  [GhostState.RECOVERING]: [GhostState.ESCAPING, GhostState.ROAMING],
  [GhostState.CAPTURED]: [],
};

export class GhostStateMachine {
  private current: GhostState;
  private enteredAt = 0;

  constructor(initial: GhostState = GhostState.IDLE) {
    this.current = initial;
  }

  get state(): GhostState { return this.current; }
  get timeInStateMs(): number { return performance.now() - this.enteredAt; }

  canTransition(next: GhostState): boolean {
    return TRANSITIONS[this.current].includes(next);
  }

  transition(next: GhostState, force = false): boolean {
    if (next === this.current) return true;
    if (!force && !this.canTransition(next)) return false;
    this.current = next;
    this.enteredAt = performance.now();
    return true;
  }
}
